export default "__VITE_ASSET__d589cc07__"